module.exports = __webpack_public_path__ + "fonts/iconfont.a4d8f085.eot";